import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../../patterns";
import { CustomFormsLoading } from "../CustomForms.loading";

import type { CustomFormAnalyticsProps } from "./CustomFormAnalytics";

export const CustomFormAnalyticsLoadable = lazy(
  () => import("./CustomFormAnalytics")
);

export const CustomFormAnalytics = (props: CustomFormAnalyticsProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<CustomFormsLoading />}>
        <CustomFormAnalyticsLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
